"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoListItem;

var _react = _interopRequireWildcard(require("react"));

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _moment = _interopRequireDefault(require("moment"));

var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));

var _reactDom = require("react-dom");

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _utils = require("../../../../../utils");

var _colors = _interopRequireDefault(require("../../../../../styles/colors"));

require("../styles/_video-list-item.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function getRemainingTimeColor(time) {
  if (!time || time < 8) {
    return _vars.COLOURS.red.redApple;
  }

  if (time < 16) {
    return _vars.COLOURS.yellow.goldenTainoi;
  }

  return _vars.COLOURS.cyan.jungleGreen.monkey;
}

function pushToOutputUrl(output, action, history) {
  return function () {
    if (action === 'BRIEF') {
      return void history.push("/builder/".concat(output.videoId));
    }

    if (action === 'PROJECT') {
      return void history.push("/project/".concat(output.video.videoProjectId));
    }

    return void history.rootPush("/review/".concat(output.videoId, "/").concat(output.outputId));
  };
}

function withNoEventPropagation(fn) {
  return function (e) {
    e.stopPropagation();
    e.preventDefault();
    fn(e);
  };
}

function getOutputStatusSpecificActions(output, history) {
  if (output.status.name === 'DRAFT' || output.status.name === 'PENDING_MASTER') {
    return [];
  }

  return [{
    action: withNoEventPropagation(pushToOutputUrl(output, 'HISTORY', history)),
    label: 'VIEW VERSION HISTORY'
  }];
}

function setActionPopupRef(setRef) {
  // We don't have access to .contains on the react ref
  // eslint-disable-next-line react/no-find-dom-node
  return function (el) {
    setRef((0, _reactDom.findDOMNode)(el));
  };
}

var onItemClick = function onItemClick(output, history, actionPopupRef) {
  return withNoEventPropagation(function (e) {
    if (actionPopupRef && actionPopupRef.contains(e.target)) {
      return;
    }

    if (output.status.name === 'DRAFT' || output.status.name === 'PENDING_MASTER' || output.status.name === 'COST_REVIEW' && !output.video.submittedAt) {
      return void history.push("/builder/".concat(output.videoId));
    }

    if (output.status.name === 'APPROVED') {
      return void history.push("/complete/".concat(output.videoId, "/").concat(output.outputId));
    }

    history.rootPush("/review/".concat(output.videoId, "/").concat(output.outputId));
  });
};

function VideoListItem(_ref) {
  var history = _ref.history,
      output = _ref.output,
      onDelete = _ref.onDelete,
      onShare = _ref.onShare,
      isShowArchived = _ref.isShowArchived,
      onToggleArchived = _ref.onToggleArchived,
      onViewDetails = _ref.onViewDetails;
  var video = output.video,
      status = output.status,
      latestVersion = output.latestVersion,
      versions = output.versions,
      isMaster = output.isMaster,
      readableId = output.readableId;
  var creator = video.creator;
  var creatorName = creator ? "".concat(creator.firstName, " ").concat(creator.lastName) : '';

  var _ref2 = versions.find(function (_ref3) {
    var versionNumber = _ref3.versionNumber;
    return versionNumber === latestVersion;
  }) || {},
      dueDate = _ref2.dueDate,
      assetId = _ref2.assetId;

  var dueDateLeft = dueDate ? (0, _moment.default)(dueDate, 'x').diff((0, _moment.default)(), 'hours') : 0;
  var remainingTime = dueDateLeft < 0 ? '0h' : "".concat(dueDateLeft, "h");

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      actionPopupRef = _useState2[0],
      setRef = _useState2[1];

  var onClick = onItemClick(output, history, actionPopupRef);
  var hasSLA = status.name !== 'DRAFT' && status.name !== 'PENDING_MASTER' && status.name !== 'APPROVED';
  var previewAssetId = assetId || video.assetIds && video.assetIds[0];
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item",
      onClick: onClick,
      tabIndex: 0,
      onKeyDown: (0, _onEnterPressed.default)({
        onClick: onClick
      }),
      role: "button"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__preview"
    }, hasSLA ? /*#__PURE__*/_react.default.createElement("p", {
      className: "video-list-item__preview__version",
      style: {
        background: _colors.default[status.name]
      }
    }, "V".concat(latestVersion)) : null, /*#__PURE__*/_react.default.createElement("button", {
      className: "video-list-item__preview__id",
      onClick: withNoEventPropagation(function () {
        return (0, _copyToClipboard.default)(readableId);
      }),
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("span", null, readableId)), !previewAssetId ? /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
      defaultImageIcon: "video",
      defaultIconColour: "russian",
      defaultIconSize: 75,
      height: "180px",
      width: "300px"
    }) : /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
      assetId: previewAssetId,
      height: "180px",
      width: "300px",
      borderRadius: 6,
      hideFileTypeIcon: true,
      canPlayVideo: false,
      darkMode: true
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__header"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "video-list-item__body__header__status",
      style: {
        color: _colors.default[status.name]
      }
    }, (0, _utils.getOutputStatusLabel)(status.name)), /*#__PURE__*/_react.default.createElement(_uiKit.ActionPopup, {
      ref: setActionPopupRef(setRef),
      popupBtn: /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        color: "regent",
        name: "options"
      }),
      options: [{
        action: withNoEventPropagation(onViewDetails(output)),
        label: 'VIEW DETAILS'
      }, {
        action: withNoEventPropagation(pushToOutputUrl(output, 'BRIEF', history)),
        label: 'VIEW VIDEO BRIEF'
      }].concat(_toConsumableArray(getOutputStatusSpecificActions(output, history)), [{
        action: withNoEventPropagation(pushToOutputUrl(output, 'PROJECT', history)),
        label: 'VIEW PROJECT'
      }, {
        action: withNoEventPropagation(onShare),
        label: 'SHARE WITH OTHERS'
      }, {
        action: withNoEventPropagation(onToggleArchived),
        label: !isShowArchived ? 'ARCHIVE' : 'UNARCHIVE'
      }, {
        action: withNoEventPropagation(onDelete(output)),
        label: 'DELETE',
        isRed: true
      }])
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__name"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "video-list-item__body__name__text"
    }, (0, _getVideoOutputName.default)(output, video.name)), isMaster ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: "master",
      color: "goldenTainoi",
      size: 20
    }) : null), /*#__PURE__*/_react.default.createElement("p", {
      className: "video-list-item__body__due"
    }, hasSLA && dueDate ? (0, _moment.default)(dueDate, 'x').format('[Due] Do MMMM YYYY') : ''), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__footer"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__footer__creator"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
      circular: true,
      height: "30px",
      width: "30px",
      placeholderText: creatorName,
      imageUrl: (0, _lodash.default)(creator, 'imageUrl'),
      placeholderTextSize: 10
    }), /*#__PURE__*/_react.default.createElement("p", null, creatorName)), /*#__PURE__*/_react.default.createElement("p", {
      className: "video-list-item__body__footer__time",
      style: {
        color: getRemainingTimeColor(dueDateLeft)
      }
    }, hasSLA && dueDate ? remainingTime : ''))))
  );
}